// The hub's file policy (TX-US-0028): any type, 25 MB each, twenty on a session. It mirrors
// trex/hub/attachments.py and MAX_ATTACHMENTS in trex/hub/models.py; the API is the authority.

import { MAX_UPLOAD_BYTES } from '../documents/files.js';

export const MAX_ATTACHMENTS = 20;

export function validateHubFile(file) {
  if (file.size <= 0) return 'The selected file is empty.';
  if (file.size > MAX_UPLOAD_BYTES) return 'The selected file is larger than 25 MB.';
  return null;
}

// How many more files a session with `attached` files and `queued` uploads in flight may take.
export const roomFor = (attached, queued) => Math.max(0, MAX_ATTACHMENTS - attached - queued);
